import { Routes, Route } from "react-router-dom";
import React, { useEffect } from "react";
import Header from "./Header.jsx";
import Footer from "./Footer.jsx";
import Home from "./Home.jsx";
import ScenarioAnalysis from "./ScenarioAnalysis.jsx";
import RiskFactorAnalysis from "./RiskFactorAnalysis.jsx";
import Benchmarking from "./Benchmarking.jsx";
import TimeSeriesForecasting from "./TimeSeriesForecasting.jsx";
import icon from "../images/favicon.ico";

function App() {
	useEffect(() => {
		const favicon = document.getElementById("favicon");
		favicon.setAttribute("href", icon);
	}, []);

	return (
		<div>
			<Header />
			<Routes>
				<Route path="*" element={<Home />} />
				<Route
					path="scenario-analysis"
					element={<ScenarioAnalysis />}
				/>
				<Route
					path="risk-factor-analysis"
					element={<RiskFactorAnalysis />}
				/>
				<Route path="benchmarking" element={<Benchmarking />} />
				<Route
					path="time-series-forecasting"
					element={<TimeSeriesForecasting />}
				/>
			</Routes>
			<Footer />
		</div>
	);
}

export default App;
